export default __webpack_public_path__ + "static/media/narayana-logo.943a13fc.svg";